webpackJsonp([2],{

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qs__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'error',
    data: function data() {
        return {
            msg: '',
            code: '',
            from: ''
        };
    },

    methods: {},
    created: function created() {
        var _this = this;

        var _query = this.$route ? this.$route.query : __WEBPACK_IMPORTED_MODULE_0_qs___default.a.parse(window.location.search.substr(1));['msg', 'code', 'from'].forEach(function (k) {
            _this[k] = _query[k];
        });
    }
});

/***/ }),

/***/ 142:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 143:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(143)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(146),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2b8ff72c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 146:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello text-center"
  }, [_c('div', {
    staticClass: "error-bg"
  }), _vm._v(" "), (_vm.code) ? _c('div', {
    staticClass: "error-code"
  }, [_vm._v(_vm._s(_vm.code))]) : _vm._e(), _vm._v(" "), _c('h1', {
    staticClass: "error-msg"
  }, [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('h2', [_c('a', {
    staticClass: "return-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$root.goKKPage($event)
      }
    }
  }, [_vm._v("返回施小慧")])])])
},staticRenderFns: []}

/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_style_css__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Err_vue__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Err_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Err_vue__);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_mint_ui___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

if (window.kk) {
    kk.ready(function () {
        kk.app.hideTitleBar();
    });
}

/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    el: '#app',
    template: '<Err/>',
    components: { Err: __WEBPACK_IMPORTED_MODULE_3__Err_vue___default.a },
    data: {
        deviceType: ''
    },
    created: function created() {
        var ua = window.navigator.userAgent;
        if (ua.match(/Android/)) {
            this.deviceType = 'android';
        }
        if (ua.match(/(iPhone|iPad)/)) {
            this.deviceType = 'ios';
        }
    },
    mounted: function mounted() {
        (function () {
            var src = '//cdn.jsdelivr.net/npm/eruda';
            if (!/eruda=true/.test(window.location) && localStorage.getItem('active-eruda') != 'true') return;
            document.write('<scr' + 'ipt src="' + src + '"></scr' + 'ipt>');
            document.write('<scr' + 'ipt>eruda.init();</scr' + 'ipt>');
        })();
    },

    methods: {
        goKKPage: function goKKPage() {
            if (window.kk) {
                kk.app.exit();
            }
        },
        dataLoading: function dataLoading() {
            this.$indicator.open({
                text: '加载中...',
                spinnerType: 'snake'
            });
        },
        dataLoaded: function dataLoaded() {
            this.$indicator.close();
        },
        toIndex: function toIndex() {
            this.$router.push('/');
            window.location.reload();
        }
    }
}));

/***/ }),

/***/ 236:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Error__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_Error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__pages_Error__);



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'err',
    data: function data() {
        return {
            loaded: true
        };
    },

    components: {
        "error-page": __WEBPACK_IMPORTED_MODULE_0__pages_Error___default.a
    }
});

/***/ }),

/***/ 539:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 569:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(539)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(236),
  /* template */
  __webpack_require__(621),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 621:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('error-page')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(215);


/***/ })

},[644]);


// WEBPACK FOOTER //
// static/js/err.0e4a282cef9bc0065454.js